import { FC, useMemo } from 'react';
import { Modal } from '@components/Modals/Modal';
import { useUnblockFlow } from '@hooks/useUnblockFlow';
import { UnblockStep } from './UnblockStep';
import { UnblockSuccessStep } from './UnblockSuccessStep';
interface IProps {
  onClose: () => void;
  targetShortId: string;
  isOpen: boolean;
}
export const UnblockFlow: FC<IProps> = ({
  onClose,
  targetShortId,
  isOpen
}) => {
  const {
    isUnblockModalVisible,
    isSuccessModalVisible,
    hideModals,
    handleUnblock,
    showSuccessModal
  } = useUnblockFlow({
    targetShortId,
    onClose
  });
  const modalComponents = useMemo(() => ({
    unblock: <UnblockStep onSubmit={showSuccessModal} onCancel={hideModals} authorName={targetShortId} />,
    success: <UnblockSuccessStep onComplete={handleUnblock} authorName={targetShortId} />
  }) as const, [handleUnblock, hideModals, targetShortId]);
  const renderModal = () => {
    if (isUnblockModalVisible) return modalComponents.unblock;
    if (isSuccessModalVisible) return modalComponents.success;
    return null;
  };
  const handleClose = () => {
    if (isSuccessModalVisible) {
      handleUnblock();
    }
    onClose();
    hideModals();
  };
  return <Modal isOpen={isOpen} onClose={handleClose} data-sentry-element="Modal" data-sentry-component="UnblockFlow" data-sentry-source-file="UnblockFlow.tsx">
			{renderModal()}
		</Modal>;
};